import { buildGetApiClient } from '@b-stock/fe-core/bstock-next/queries'
import { CanadianTaxApi } from '@b-stock/listing-api-client'

/**
 * Returns a shared `CanadianTaxApi` instance configured against the
 * `LISTINGS` host, the same host fe-core's `getListingsClient()` is
 * already pointed at. The two endpoints we consume —
 * `GET /v1/canadian-tax/listings/:id/running-estimate` (T074) and
 * `GET /v1/canadian-tax/listings/:id/max-exposure` (T075) — are both
 * mounted by the listing service per Phase 4 / US2 of the
 * Canadian-tax spec.
 *
 * Created locally rather than waiting on fe-core to add
 * `getCanadianTaxClient()` directly — the underlying client class
 * (`CanadianTaxApi` from `@b-stock/listing-api-client@^16.6.1`) is
 * already published, so the only thing missing upstream is the wiring,
 * which `buildGetApiClient` ships generically. Once fe-core surfaces
 * this client natively this file can be deleted and consumers
 * re-pointed.
 */
const getCanadianTaxClient = buildGetApiClient('LISTINGS', CanadianTaxApi)

export default getCanadianTaxClient
